<!-- SITE CONFIGURATION HEADER -->
<div class="row" style="margin: 17px">
	<div class="col-sm-2">
		<h1 style="margin-top: 0px; margin-bottom: 0px"><i class="fa fa-map-o" aria-hidden="true"></i> SITES</h1>
	</div>
	<div class="col-sm-2">
		<button (click)="createLocationClicked()" type="button" class="btn btn-ef pull-right">
			<em class="fa fa-plus"></em> CREATE
		</button>
	</div>
	<div class="col-sm-6">
		<app-sites-header-nav
			[location]="mSelectedLocation"
			(locationClicked)="loadLocationAttempt($event)"
			>
		</app-sites-header-nav>
		<!-- <span style="font-size: 32px; color: rgb(255, 255, 255);">{{this.mSelectedLocation == null? "" : this.mSelectedLocation.name}}</span> -->
	</div>
	<div class="col-sm-2">
		<span style="font-size: 12px; color: #2a2a2a;"></span>
	</div>
</div>

<!-- SITE CONFIGURATION BODY -->
<div class="container-fluid" style="height: calc(100% - 100px)">
	<div class="row" style="height: 100%">

		<!-- Left Hand Side Tabs/Controls -->
		<div class="col-sm-4" id="dataPaneOuter" style="height: 100%">
			<div id="dataPane" style="overflow-y: auto; background-color: #171717; height: 100%;">

				<!-- Main Navigation Tabs Headers (SITES/LOCATION/ZONES/OBJECTS) -->
				<ul class="nav nav-tabs" style="background-color: #000000;">
					<li (click)='selectMainTab(mMainTabTypes.SITES)' class="active">
						<a data-toggle="tab" href="#sitesTab">SITES</a>
					</li>
					<li (click)='selectMainTab(mMainTabTypes.LOCATION)' [class.disabled]="mSelectedLocation == null">
						<a [attr.data-toggle]="mSelectedLocation == null? null : 'tab'" [style.cursor]="mSelectedLocation == null? 'no-drop' : 'pointer'" [attr.href]="mSelectedLocation == null? null : '#' + mLocationTabId">LOCATION</a>
					</li>
					<li (click)='selectMainTab(mMainTabTypes.SUBLOCATIONS)' [class.disabled]="mSelectedLocation == null">
						<a [attr.data-toggle]="mSelectedLocation == null? null : 'tab'" [style.cursor]="mSelectedLocation == null? 'no-drop' : 'pointer'" [attr.href]="mSelectedLocation == null? null : '#' + mSubLocationsTabId">SUBLOCATIONS</a>
					</li>
					<li (click)='selectMainTab(mMainTabTypes.ZONES)' [class.disabled]="mSelectedLocation == null">
						<a [attr.data-toggle]="mSelectedLocation == null? null : 'tab'" [style.cursor]="mSelectedLocation == null? 'no-drop' : 'pointer'" [attr.href]="mSelectedLocation == null? null : '#' + mZonesTabId">ZONES</a>
					</li>
					<li (click)='selectMainTab(mMainTabTypes.OBJECTS)' [class.disabled]="mSelectedLocation == null">
						<a [attr.data-toggle]="mSelectedLocation == null? null : 'tab'" [style.cursor]="mSelectedLocation == null? 'no-drop' : 'pointer'" [attr.href]="mSelectedLocation == null? null : '#' + mObjectsTabId">OBJECTS</a>
					</li>
				</ul>


				<!-- Main Navigation Tabs Content -->
				<div class="tab-content" style="margin: 0;">

					<!-- SITES Tab - Select Site Location -->
					<div id="sitesTab" class="tab-pane fade in active" style="margin: 0px; padding: 10px">
						<ul class="nav">
							<ng-container *ngIf="mSiteLocations != null">
								<li *ngFor="let location of mSiteLocations">
									<a (click)="siteLocationClicked(location)" class="siteLocationSelector">{{location.name}}</a>
								</li>
							</ng-container>
						</ul>
					</div>

					<!-- LOCATION Tab - Display information about the displayed Location -->
					<div id="{{mLocationTabId}}" class="tab-pane fade"  style="margin: 0; padding: 10px; width: calc(100% - 5px)">
						<div class="form-group">

							<!-- Location Name -->
							<div *ngIf="mEditableLocation != null" class="row">
								<label class="col-sm-2">NAME</label>
								<span class="col-sm-10"><input [(ngModel)]="mEditableLocation.name" type="text" style="width: 100%;" class="form-control"></span>
							</div>

							<!-- Location Type -->
							<div *ngIf="mEditableLocation != null" class="row">
								<label class="col-sm-2">TYPE</label>
								<div class="col-sm-10">
									<div class="dropdown">
										<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
											{{mEditableLocation.location.name}} <span class="caret"></span>
										</button>
										<ul class="dropdown-menu" style="height: 250px; overflow-y: auto">
											<li *ngFor="let locationType of mLocationTypes">
												<a (click)="mEditableLocation.location = locationType" class="ef">{{locationType.name}}</a>
											</li>
										</ul>
									</div>
								</div>
							</div>

							<!-- Mini Map of Location Image -->
							<div class="row">
								<label class="col-sm-2">IMAGE</label>
								<table style="border:0; background-color: inherit; margin: 25px; width: 300px;">
									<tbody>
										<tr>
											<!-- Height Display  -->
											<td style="vertical-align: middle; text-align: center">
												<em class="fa fa-arrow-up"></em><br>
												<label>{{mMiniMapHeightDisplay}}</label><br>
												<em class="fa fa-arrow-down"></em>
											</td>

											<!-- Mini Map  -->
											<td style="width: 100%; text-align:center">
												<canvas id="{{mMiniMapCanvasId}}" width="{{mMiniMapSize}}" height="{{mMiniMapSize}}"></canvas>
											</td>
										</tr>

										<!-- Width Display  -->
										<tr>
											<td>&nbsp;</td>
											<td style="text-align: center">
												<em class="fa fa-arrow-left"></em>
												<label style="margin-right: 5px; margin-left: 5px;">{{mMiniMapWidthDisplay}}</label>
												<em class="fa fa-arrow-right"></em>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- Scale Display -->
							<div class="row">
								<label for="scaleForLocation" class="col-sm-3">SCALE</label>
								<span class="col-sm-6">{{mLocationScaleDisplay}}</span>
								<span class="col-sm-3">&nbsp;</span>
							</div>

							<!-- Location Description -->
							<div *ngIf="mEditableLocation != null" class="row">
								<label for="locationDescription" class="col-sm-3">DESCRIPTION</label>
								<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mEditableLocation.description"></textarea></span>
							</div>
						</div>
					</div>

					<!-- SUBLOCATIONS Tab -->
					<div id="{{mSubLocationsTabId}}" class="tab-pane fade" style="margin: 0; padding: 10px; width: calc(100% - 5px);">

						<!-- Display Panel showing the Sub Locations that were already created in the selected Location, allowing the User to select them to see their individual details -->
						<div *ngIf="mEditableLocation != null && mSelectedSubLocationUi == null">
							Sub Locations in <span id="locationName">{{mEditableLocation.name}}</span><br/><br/>

							<span *ngIf="mSubLocationUis.length == 0">No sub locations exist</span>

							<ul *ngIf="mSubLocationUis.length > 0" class="nav">
								<li *ngFor="let ui of mSubLocationUis">
									<a (click)="selectSubLocationUi(ui)" style="cursor: pointer;"><i *ngIf="ui.isSubLocationChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>{{ui.mSubLocation.name}}</a>
								</li>
							</ul>
						</div>


						<div *ngIf="mEditableLocation != null && mSelectedSubLocationUi != null">

							<!-- Back to All Sub Locations Navigation -->
							<div class="row" style="margin-left: 5px;">
								<a (click)="selectSubLocationUi(null)" style="cursor: pointer">&lt;&lt; All Sub Locations</a>
							</div>

							<!-- Sub Location Information -->
							<div class="form-group" style="padding: 10px">

								<!-- Sub Location Name -->
								<div class="row">
									<label class="col-sm-2">NAME</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedSubLocationUi.mSubLocation.name" (ngModelChange)="subLocationNameChanged()" type="text" style="width: 100%;" class="form-control"></span>
								</div>

								<!-- Sub Location Type -->
								<div class="row">
									<label class="col-sm-2">TYPE</label>
									<div class="col-sm-10">
										<div class="dropdown">
											<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												{{mSelectedSubLocationUi.mSubLocation.location.name}} <span class="caret"></span>
											</button>
											<ul class="dropdown-menu" style="height: 250px; overflow-y: auto">
												<li *ngFor="let locationType of mLocationTypes">
													<a (click)="mSelectedSubLocationUi.mSubLocation.location = locationType" class="ef">{{locationType.name}}</a>
												</li>
											</ul>
										</div>
									</div>
								</div>

								<!-- Sub Location Color -->
								<div class="row">
									<label class="col-sm-2">BACK COLOR</label>
									<span class="col-sm-10"><input type="color" [(ngModel)]="mSelectedSubLocationUiColor" (ngModelChange)="subLocationColorChanged()" /></span>
								</div>

                <!-- Sub Location Text Color -->
                <div class="row">
                  <label class="col-sm-2">TEXT COLOR</label>
                  <span class="col-sm-10"><input type="color" [(ngModel)]="mSelectedSubLocationUiTextColor" (ngModelChange)="subLocationTextColorChanged()" /></span>
                </div>

								<!-- Sub Location Description -->
								<div class="row">
									<label class="col-sm-3">DESCRIPTION</label>
									<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mSelectedSubLocationUi.mSubLocation.description"></textarea></span>
								</div>

							</div>

							<!-- Zone Update/Delete Buttons -->
							<div class="row">
								<div class="col-sm-4">
									<button (click)="deleteSubLocationClicked()" class="btn btn-default" type="button">DELETE</button>
									<button (click)="drawSubLocationClicked()" class="btn btn-ef" type="button" style="margin-left: 5px">DRAW</button>
								</div>
								<div class="col-sm-4">&nbsp;</div>
								<div class="col-sm-1"><span *ngIf="mSelectedSubLocationUi.isSubLocationChanged()"><i class="fa fa-2x fa-exclamation-circle" style="color: yellow"></i></span></div>
								<div class="col-sm-3">
									<button *ngIf="!mSelectedSubLocationUi.isSubLocationNew()" (click)="updateSubLocationClicked()" [class.disabled]="!mSelectedSubLocationUi.isSubLocationChanged()" class="btn btn-ef" type="button">UPDATE</button>
									<button *ngIf="mSelectedSubLocationUi.isSubLocationNew()" (click)="createSubLocationClicked()" class="btn btn-ef" type="button">CREATE</button>
								</div>
							</div>

						</div>
					</div>

					<!-- ZONES Tab -->
					<div id="{{mZonesTabId}}" class="tab-pane fade" style="margin: 0; padding: 10px; width: calc(100% - 5px);">

						<!-- Display Panel showing the Zones that were already created in the selected Location, allowing the User to select them to see their individual details -->
						<div *ngIf="mEditableLocation != null && mSelectedZoneUi == null">
							Zones in <span id="locationName">{{mEditableLocation.name}}</span><br/><br/>

							<span *ngIf="mZoneUis.length == 0">No zones exist</span>

							<ul *ngIf="mZoneUis.length > 0" class="nav">
								<li *ngFor="let ui of mZoneUis">
									<a (click)="selectZoneUi(ui)" style="cursor: pointer;"><i *ngIf="ui.isZoneChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>{{ui.mZone.name}}</a>
								</li>
							</ul>
						</div>


						<div *ngIf="mEditableLocation != null && mSelectedZoneUi != null">

							<!-- Back to All Zone Navigation -->
							<div class="row" style="margin-left: 5px;">
								<a (click)="selectZoneUi(null)" style="cursor: pointer">&lt;&lt; All Zones</a>
							</div>

							<!-- Zone Information -->
							<div class="form-group" style="padding: 10px">

								<!-- Zone Name -->
								<div class="row">
									<label class="col-sm-2">NAME</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedZoneUi.mZone.name" (ngModelChange)="zoneNameChanged()" type="text" style="width: 100%;" class="form-control"></span>
								</div>

								<!-- Zone Type -->
								<div class="row">
									<label class="col-sm-2">TYPE</label>
									<div class="col-sm-10">
										<div class="dropdown">
											<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
												{{mSelectedZoneUi.mZone.zone.name}} <span class="caret"></span>
											</button>
											<ul class="dropdown-menu" style="height: 250px; overflow-y: auto">
												<li *ngFor="let zoneType of mZoneTypes">
													<a (click)="mSelectedZoneUi.mZone.zone = zoneType" class="ef">{{zoneType.name}}</a>
												</li>
											</ul>
										</div>
									</div>
								</div>

								<!-- Zone Color -->
								<div class="row">
									<label class="col-sm-2">BACK COLOR</label>
									<span class="col-sm-10"><input type="color" [(ngModel)]="mSelectedZoneUiColor" (ngModelChange)="zoneColorChanged()" /></span>
								</div>

                <!-- Zone Text Color -->
                <div class="row">
                  <label class="col-sm-2">TEXT COLOR</label>
                  <span class="col-sm-10"><input type="color" [(ngModel)]="mSelectedZoneUiTextColor" (ngModelChange)="zoneTextColorChanged()" /></span>
                </div>

								<!-- Zone Description -->
								<div class="row">
									<label class="col-sm-3">DESCRIPTION</label>
									<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mSelectedZoneUi.mZone.description"></textarea></span>
								</div>

							</div>

							<!-- Zone Update/Delete Buttons -->
							<div class="row">
								<div class="col-sm-4">
									<button (click)="deleteZoneClicked()" class="btn btn-default" type="button">DELETE</button>
									<button (click)="drawZoneClicked()" class="btn btn-ef" type="button" style="margin-left: 5px">DRAW</button>
								</div>
								<div class="col-sm-4">&nbsp;</div>
								<div class="col-sm-1"><span *ngIf="mSelectedZoneUi.isZoneChanged()"><i class="fa fa-2x fa-exclamation-circle" style="color: yellow"></i></span></div>
								<div class="col-sm-3">
									<button *ngIf="!mSelectedZoneUi.isZoneNew()" (click)="updateZoneClicked()" [class.disabled]="!mSelectedZoneUi.isZoneChanged()" class="btn btn-ef" type="button">UPDATE</button>
									<button *ngIf="mSelectedZoneUi.isZoneNew()" (click)="createZoneClicked()" class="btn btn-ef" type="button">CREATE</button>
								</div>
							</div>

						</div>
					</div>

					<!-- OBJECTS Tab -->
					<div id="{{mObjectsTabId}}" class="tab-pane fade" style="margin: 0px; padding: 10px;">

						<!-- Navigation Buttons  (Antennas/Readers/Devices/Assets) -->
						<div id="objectsDataPaneButtons">

							<!-- ANTENNAS -->
							<div class="col-sm-3" style="padding-left: 5px; padding-right: 5px">
								<div (click)='selectObjectTab(mObjectTabTypes.ANTENNAS)' [style.background-color]="mSelectedObjectTab != mObjectTabTypes.ANTENNAS? 'rgb(23, 23, 23)' : 'rgb(51, 51, 51)'" class="panel panel-drk-ornge edgefinityButton" style="margin-bottom: 4px;">
									<div class="panel-body" style="height: 64px; overflow: hidden; max-height: 100%">
										<div style="overflow: hidden; align-content: center"><i class="fa fa-2x fa-feed" aria-hidden="true" style="color: #f57300"></i></div>
										<div style="font-size: 12px; align-content: center; color: #e65100">ANTENNAS</div>
									</div>
								</div>
							</div>

							<!-- READERS -->
							<div class="col-sm-3" style="padding-left: 5px; padding-right: 5px">
								<div (click)='selectObjectTab(mObjectTabTypes.READERS)' [style.background-color]="mSelectedObjectTab != mObjectTabTypes.READERS? 'rgb(23, 23, 23)' : 'rgb(51, 51, 51)'" class="panel panel-drk-ornge edgefinityButton" style="margin-bottom: 4px;">
									<div class="panel-body" style="height: 64px; overflow: hidden; max-height: 100%">
										<div style="overflow: hidden; align-content: center"><i class="fa fa-2x fa-rss-square" aria-hidden="true" style="color: #f57300"></i></div>
										<div style="font-size: 12px; align-content: center; color: #e65100">READERS</div>
									</div>
								</div>
							</div>

							<!-- DEVICES -->
							<div class="col-sm-3" style="padding-left: 5px; padding-right: 5px">
								<div (click)='selectObjectTab(mObjectTabTypes.DEVICES)' [style.background-color]="mSelectedObjectTab != mObjectTabTypes.DEVICES? 'rgb(23, 23, 23)' : 'rgb(51, 51, 51)'" class="panel panel-drk-ornge edgefinityButton" style="margin-bottom: 4px;">
									<div class="panel-body" style="height: 64px; overflow: hidden; max-height: 100%">
										<div style="overflow: hidden; align-content: center"><i class="fa fa-2x fa-microchip" aria-hidden="true" style="color: #f57300"></i></div>
										<div style="font-size: 12px; align-content: center; color: #e65100">DEVICES</div>
									</div>
								</div>
							</div>

							<!-- ASSETS -->
							<div class="col-sm-3" style="padding-left: 5px; padding-right: 5px">
								<div (click)='selectObjectTab(mObjectTabTypes.ASSETS)' [style.background-color]="mSelectedObjectTab != mObjectTabTypes.ASSETS? 'rgb(23, 23, 23)' : 'rgb(51, 51, 51)'" class="panel panel-drk-ornge edgefinityButton" style="margin-bottom: 4px;">
									<div class="panel-body" style="height: 64px; overflow: hidden; max-height: 100%">
										<div style="overflow: hidden; align-content: center"><i class="fa fa-2x fa-star-o" aria-hidden="true" style="color: #f57300"></i></div>
										<div style="font-size: 12px; align-content: center; color: #e65100">ASSETS</div>
									</div>
								</div>
							</div>
						</div>


						<!-- Displays Lists of the various Object Types, seperating them into "IN LOCATION" and "NOT IN LOCATION" groups -->
						<div *ngIf="mSelectedObjectTab != null && !(mSelectedObjectTab == mObjectTabTypes.ANTENNAS && mSelectedAntennaUi != null) && !(mSelectedObjectTab == mObjectTabTypes.READERS && mSelectedReaderUi != null) && !(mSelectedObjectTab == mObjectTabTypes.ASSETS && mSelectedAssetUi != null) && !(mSelectedObjectTab == mObjectTabTypes.DEVICES && mSelectedDeviceUi != null)" class="container-fluid">

							<div class="row">
								<div class="col-sm-6" style="padding-left: 4px; padding-right: 4px">
									<div class="objectsHeader"><b>IN LOCATION</b></div>
								</div>
								<div class="col-sm-6" style="padding-left: 4px; padding-right: 4px">
									<div class="objectsHeader"><b>ELSEWHERE</b></div>
								</div>
							</div>

							<div class="row">

								<!-- IN LOCATION -->
								<div [ngSwitch]="mSelectedObjectTab" class="col-sm-6" id="objectsDataPaneObjectsInLocation" style="height: 50%; overflow-y: auto;">
									<ul *ngSwitchCase="mObjectTabTypes.ANTENNAS" class="nav" style="list-style: none">
										<li *ngFor="let ui of mAntennasInLocation">
											<a (click)="selectAntennaUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isAntennaChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForAntenna(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mAntenna.name}}
											</a>
										</li>
									</ul>
									<ul *ngSwitchCase="mObjectTabTypes.READERS" class="nav" style="list-style: none">
										<li *ngFor="let ui of mReadersInLocation">
											<a (click)="selectReaderUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isReaderChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForReader(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mReader.name}}
											</a>
										</li>
									</ul>
									<ul *ngSwitchCase="mObjectTabTypes.DEVICES" class="nav" style="list-style: none">
										<li *ngFor="let ui of mDevicesInLocation">
											<a (click)="selectDeviceUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isObjectChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForObject(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mObject.name}}
											</a>
										</li>
									</ul>
									<ul *ngSwitchCase="mObjectTabTypes.ASSETS" class="nav" style="list-style: none">
										<li *ngFor="let ui of mAssetsInLocation">
											<a (click)="selectAssetUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isObjectChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForObject(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mObject.name}}
											</a>
										</li>
									</ul>
								</div>

								<!-- ELSEWHERE -->
								<div [ngSwitch]="mSelectedObjectTab" class="col-sm-6" id="objectsDataPaneObjectsAvailable" style="height: 50%; overflow-y: auto;">
									<ul *ngSwitchCase="mObjectTabTypes.ANTENNAS" class="nav" style="list-style: none">
										<li *ngFor="let ui of mAntennasNotInLocation">
											<a (click)="selectAntennaUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isAntennaChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForAntenna(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mAntenna.name}}
											</a>
										</li>
									</ul>
									<ul *ngSwitchCase="mObjectTabTypes.READERS" class="nav" style="list-style: none">
										<li *ngFor="let ui of mReadersNotInLocation">
											<a (click)="selectReaderUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isReaderChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForReader(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mReader.name}}
											</a>
										</li>
									</ul>
									<ul *ngSwitchCase="mObjectTabTypes.DEVICES" class="nav" style="list-style: none">
										<li *ngFor="let ui of mDevicesNotInLocation">
											<a (click)="selectDeviceUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isObjectChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForObject(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mObject.name}}
											</a>
										</li>
									</ul>
									<ul *ngSwitchCase="mObjectTabTypes.ASSETS" class="nav" style="list-style: none">
										<li *ngFor="let ui of mAssetsNotInLocation">
											<a (click)="selectAssetUi(ui)" style="padding: 5px 5px; cursor: pointer;">
												<i *ngIf="ui.isObjectChanged()" class="fa fa-exclamation-circle" style="color: yellow;">&nbsp;</i>
												<img src="{{getIconPathForObject(ui)}}" style="max-height: 20px; max-width: 20px;"> {{ui.mObject.name}}
											</a>
										</li>
									</ul>
								</div>

							</div>

						</div>

						<!-- Selected Antenna Display -->
						<div *ngIf="mSelectedObjectTab == mObjectTabTypes.ANTENNAS && mSelectedAntennaUi != null" style="margin: 0; padding: 10px;">

							<!-- Back to All Antennas Navigation -->
							<div class="row" style="margin-left: 5px;">
								<a (click)="selectAntennaUi(null)" style="cursor: pointer">&lt;&lt; All Antennas</a>
							</div>

							<!-- Antenna Information -->
							<div class="form-group">

								<!-- Antenna Name -->
								<div class="row">
									<label class="col-sm-2">NAME</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedAntennaUi.mAntenna.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Antenna Type -->
								<div class="row">
									<label class="col-sm-2">TYPE</label>
									<div class="col-sm-10">
										<div class="dropdown">
											<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>
												{{mSelectedAntennaUi.mAntenna.antenna.name}} <span class="caret"></span>
											</button>
										</div>
									</div>
								</div>

								<!-- Antenna Description -->
								<div class="row">
									<label class="col-sm-3">DESCRIPTION</label>
									<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mSelectedAntennaUi.mAntenna.description" disabled></textarea></span>
								</div>

								<!-- Antenna Location -->
								<div class="row">
									<label class="col-sm-2">LOCATION</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedAntennaUi.mAntenna.locationInstance == null? null : mSelectedAntennaUi.mAntenna.locationInstance.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Antenna Position -->
								<div class="row">
									<label class="col-sm-2">POSITION</label>
									<span class="col-sm-10"><input value="{{getPointDisplay(mSelectedAntennaUi.mAntenna.position)}}" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>
							</div>

							<!-- Antenna Update/Delete Buttons -->
							<div class="row">
								<div class="col-sm-4">
									<button class="btn btn-ef" style="margin-right: 5px;" (click)="placeAntennaClicked()">PLACE</button>
									<button class="btn btn-ef" (click)="removeAntennaClicked()" *ngIf="mSelectedAntennaUi.mAntenna.locationInstance != null && mSelectedAntennaUi.mAntenna.locationInstance.id == mEditableLocation.id">REMOVE</button>
								</div>
								<div class="col-sm-4"><button class="btn btn-ef" style="margin-right: 5px;" (click)="setZCoordinateClicked()">SET Z-COORD</button></div>
								<div class="col-sm-1"><span *ngIf="mSelectedAntennaUi.isAntennaChanged()"><i class="fa fa-2x fa-exclamation-circle" style="color: yellow"></i></span></div>
								<div class="col-sm-3">
									<button  (click)="saveAntennaClicked()" class="btn btn-ef">SAVE</button>
								</div>
							</div>
						</div>

						<!-- Selected Reader Display  -->
						<div *ngIf="mSelectedObjectTab == mObjectTabTypes.READERS && mSelectedReaderUi != null" style="margin: 0; padding: 10px;">

							<!-- Back to All Readers Navigation -->
							<div class="row" style="margin-left: 5px;">
								<a (click)="selectReaderUi(null)" style="cursor: pointer">&lt;&lt; All Readers</a>
							</div>

							<!-- Reader Information -->
							<div class="form-group">

								<!-- Reader Name -->
								<div class="row">
									<label class="col-sm-2">NAME</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedReaderUi.mReader.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Reader Type -->
								<div class="row">
									<label class="col-sm-2">TYPE</label>
									<div class="col-sm-10">
										<div class="dropdown">
											<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>
												{{mSelectedReaderUi.mReader.reader.name}} <span class="caret"></span>
											</button>
										</div>
									</div>
								</div>

								<!-- Reader Description -->
								<div class="row">
									<label class="col-sm-3">DESCRIPTION</label>
									<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mSelectedReaderUi.mReader.description" disabled></textarea></span>
								</div>

								<!-- Reader Location -->
								<div class="row">
									<label class="col-sm-2">LOCATION</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedReaderUi.mReader.location == null? null : mSelectedReaderUi.mReader.location.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Reader Position -->
								<div class="row">
									<label class="col-sm-2">POSITION</label>
									<span class="col-sm-10"><input value="{{getPointDisplay(mSelectedReaderUi.mReader.position)}}" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>
							</div>

							<!-- Reader Place/Remove and Save Buttons -->
							<div class="row">
								<div class="col-sm-4">
									<button class="btn btn-ef" style="margin-right: 5px;" (click)="placeReaderClicked()">PLACE</button>
									<button class="btn btn-ef" (click)="removeReaderClicked()" *ngIf="mSelectedReaderUi.mReader.location != null && mSelectedReaderUi.mReader.location.id == mEditableLocation.id">REMOVE</button>
								</div>
                <div class="col-sm-4"><button class="btn btn-ef" style="margin-right: 5px;" (click)="setZCoordinateClicked()">SET Z-COORD</button></div>
								<div class="col-sm-1"><span *ngIf="mSelectedReaderUi.isReaderChanged()"><i class="fa fa-2x fa-exclamation-circle" style="color: yellow"></i></span></div>
								<div class="col-sm-3">
									<button  (click)="saveReaderClicked()" class="btn btn-ef">SAVE</button>
								</div>
							</div>
						</div>

						<!-- Selected Device Display -->
						<div *ngIf="mSelectedObjectTab == mObjectTabTypes.DEVICES && mSelectedDeviceUi != null" style="margin: 0; padding: 10px;">

							<!-- Back to All Devices Navigation -->
							<div class="row" style="margin-left: 5px;">
								<a (click)="selectDeviceUi(null)" style="cursor: pointer">&lt;&lt; All Devices</a>
							</div>

							<!-- Device Information -->
							<div class="form-group">

								<!-- Device Name -->
								<div class="row">
									<label class="col-sm-2">NAME</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedDeviceUi.mObject.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Device Type -->
								<div class="row">
									<label class="col-sm-2">TYPE</label>
									<div class="col-sm-10">
										<div class="dropdown">
											<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>
												{{mSelectedDeviceUi.mObject.object.name}} <span class="caret"></span>
											</button>
										</div>
									</div>
								</div>

								<!-- Device Description -->
								<div class="row">
									<label class="col-sm-3">DESCRIPTION</label>
									<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mSelectedDeviceUi.mObject.description" disabled></textarea></span>
								</div>

								<!-- Device Location -->
								<div class="row">
									<label class="col-sm-2">LOCATION</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedDeviceUi.mObject.locationInstance == null? null : mSelectedDeviceUi.mObject.locationInstance.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Device Position -->
								<div class="row">
									<label class="col-sm-2">POSITION</label>
									<span class="col-sm-10"><input value="{{getPointDisplay(mSelectedDeviceUi.mObject.position)}}" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>
							</div>

							<!-- Device Place/Remove and Save Buttons -->
							<div class="row">
								<div class="col-sm-4">
									<button class="btn btn-ef" style="margin-right: 5px;" (click)="placeDeviceClicked()">PLACE</button>
									<button class="btn btn-ef" (click)="removeDeviceClicked()" *ngIf="mSelectedDeviceUi.mObject.locationInstance != null && mSelectedDeviceUi.mObject.locationInstance.id == mEditableLocation.id">REMOVE</button>
								</div>
                <div class="col-sm-4"><button class="btn btn-ef" style="margin-right: 5px;" (click)="setZCoordinateClicked()">SET Z-COORD</button></div>
								<div class="col-sm-1"><span *ngIf="mSelectedDeviceUi.isObjectChanged()"><i class="fa fa-2x fa-exclamation-circle" style="color: yellow"></i></span></div>
								<div class="col-sm-3">
									<button  (click)="saveDeviceClicked()" class="btn btn-ef">SAVE</button>
								</div>
							</div>
						</div>

						<!-- Selected Asset Display -->
						<div *ngIf="mSelectedObjectTab == mObjectTabTypes.ASSETS && mSelectedAssetUi != null" style="margin: 0; padding: 10px;">

							<!-- Back to All Assets Navigation -->
							<div class="row" style="margin-left: 5px;">
								<a (click)="selectAssetUi(null)" style="cursor: pointer">&lt;&lt; All Assets</a>
							</div>

							<!-- Asset Information -->
							<div class="form-group">

								<!-- Asset Name -->
								<div class="row">
									<label class="col-sm-2">NAME</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedAssetUi.mObject.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Asset Type -->
								<div class="row">
									<label class="col-sm-2">TYPE</label>
									<div class="col-sm-10">
										<div class="dropdown">
											<button type="button" class="btn btn-default drowndown-toggle" id="locationType_button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>
												{{mSelectedAssetUi.mObject.object.name}} <span class="caret"></span>
											</button>
										</div>
									</div>
								</div>

								<!-- Asset Description -->
								<div class="row">
									<label class="col-sm-3">DESCRIPTION</label>
									<span class="col-sm-9"><textarea class="form-control" rows="6" [(ngModel)]="mSelectedAssetUi.mObject.description" disabled></textarea></span>
								</div>

								<!-- Asset Location -->
								<div class="row">
									<label class="col-sm-2">LOCATION</label>
									<span class="col-sm-10"><input [(ngModel)]="mSelectedAssetUi.mObject.locationInstance == null? null : mSelectedAssetUi.mObject.locationInstance.name" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>

								<!-- Asset Position -->
								<div class="row">
									<label class="col-sm-2">POSITION</label>
									<span class="col-sm-10"><input value="{{getPointDisplay(mSelectedAssetUi.mObject.position)}}" type="text" style="width: 100%;" class="form-control" disabled></span>
								</div>
							</div>

							<!-- Asset Place/Remove and Save Buttons -->
							<div class="row">
								<div class="col-sm-4">
									<button class="btn btn-ef" style="margin-right: 5px;" (click)="placeAssetClicked()">PLACE</button>
									<button class="btn btn-ef" (click)="removeAssetClicked()" *ngIf="mSelectedAssetUi.mObject.locationInstance != null && mSelectedAssetUi.mObject.locationInstance.id == mEditableLocation.id">REMOVE</button>
								</div>
                <div class="col-sm-4"><button class="btn btn-ef" style="margin-right: 5px;" (click)="setZCoordinateClicked()">SET Z-COORD</button></div>
								<div class="col-sm-1"><span *ngIf="mSelectedAssetUi.isObjectChanged()"><i class="fa fa-2x fa-exclamation-circle" style="color: yellow"></i></span></div>
								<div class="col-sm-3">
									<button (click)="saveAssetClicked()" [class.disabled]="!mSelectedAssetUi.isObjectChanged()" class="btn btn-ef">SAVE</button>
								</div>
							</div>
						</div>

					</div>

				</div>
			</div>
		</div>









		<!-- Right Hand Side -->
		<div class="col-sm-8" id="sitePageTitleBar" style="height: 100%">

			<div class="row">
				<div class="col-sm-12">
					<div id="breadcrumbMenuBar" style="width: 100%; height: 70px">

						<div id="breadcrumbs" style="width: 500px"></div>

						<div class="pull-right">
							<span *ngIf="isLocationChanged()"><i class="fa fa-warning fa-2x" style="vertical-align: bottom; color: yellow; margin-right: 5px"></i></span>
							<button *ngIf="mSelectedLocation != null" [class.disabled]="!isLocationChanged()" (click)="updateLocationClicked()" type="button" class="btn btn-ef" >UPDATE LOCATION</button>
						</div>
					</div>
				</div>
			</div>

			<!-- Canvas + Controls -->
			<div class="row">
				<div class="col-sm-12" id="sitePageCanvas" style="width: 100%;">

					<!-- Main Canvas/Location Image -->
					<canvas
						id="{{mMainCanvasId}}"
						[style.cursor]="mIsPlacing || mIsDrawingZone || mIsSettingScale || mIsDrawingSubLocation? 'crosshair' : null"
						width="{{mMainCanvasWidthInPixels}}"
						height="{{mMainCanvasHeightInPixels}}"
						(mousedown)="onMouseDown($event)"
						(mousemove)="onMouseMove($event)"
						(mouseup)="onMouseUp($event)"
						(mouseleave)="onMouseLeave($event)"
						(wheel)="onMouseWheel($event)"
						>
					</canvas>

					<!-- Adjust Zoom Buttons -->
					<div id="{{mZoomSliderId}}" style="display: none; position: absolute; top: 20px; left: 0px; opacity: .8; font-size: 32px; width: 27px; text-align: center">
						<a (click)="zoomInClicked()" style="cursor: pointer"><em class="fa fa-plus-square"></em></a>
						<a (click)="zoomOutClicked()" style="cursor: pointer"><em class="fa fa-minus-square"></em></a>
					</div>

					<div id="zoomScaleDiv" style="display: none; position: absolute; bottom: 20px; right: 200px; opacity: .8">
						<label id="zoomScaleLabel" style="color: #e65100"></label>
						<div style="width: 100px; height: 10px; border-bottom: 6px solid #e65100;"></div>
					</div>

					<div *ngIf="mIsPlacing || mIsDrawingZone || mIsSettingScale || mIsDrawingSubLocation" style="position: absolute; bottom: 20px; right: 50px; opacity: 1">
						<button (click)="cancelClicked()" class="btn btn-ef"> CANCEL </button>
					</div>

					<div id="notificationBar" style="display: none; position: absolute; bottom: 10px; right: 400px; background-color: red; color: white"></div>

				</div>
			</div>

		</div>

	</div>

</div>


<input type="file" #locationImage (change)="onImageFileChanged($event)" style="display:none" accept=".gif,.jpg,.png"/>


<!-- FOOTER NAVIGATION -->
<app-sites-footer-component *ngIf="mEditableLocation != null"
	(setScaleClicked)="setScaleClicked()"
	(uploadMapClicked)="uploadMapClicked()"
	(addZoneClicked)="addZoneClicked()"
	(addSubLocationClicked)="addSubLocationClicked()"
	(toggleTrackingClicked)="toggleTrackingClicked()"
	>
</app-sites-footer-component>


<!-- SET SCALE START DIALOG (Shows Instructions) -->
<app-set-scale-start-dialog #scaleStartDialog
  (ok)="setScaleStartOkClicked()"
>
</app-set-scale-start-dialog>


<!-- SET SCALE FINISH DIALOG (Asks User how long the line they drew was) -->
<app-set-scale-finish-dialog #scaleFinishDialog
  (setScale)="setScaleFinished($event)"
>
</app-set-scale-finish-dialog>


<!-- CREATE SITE DIALOG - Displayed when "CREATE LOCATION" is clicked -->
<app-create-site-dialog #createSiteDialog
	(createdLocation)="createdLocation($event)"
	[locationTypes]="mLocationTypes"
>
</app-create-site-dialog>


<!-- UPLOADING DIALOG - Displayed when a blueprint/map is being uploaded -->
<app-uploading-dialog #uploadingDialog
>
</app-uploading-dialog>


<!-- LOCATION CHANGES WARNING DIALOG - Displayed when a User tries to load another Location while the current one has changes that weren't saved -->
<app-sites-location-changes-dialog
>
</app-sites-location-changes-dialog>


<app-set-z-coordinate-dialog #setZCoordinateDialog (setZCoordinate)="setZCoordinate($event)"></app-set-z-coordinate-dialog>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>